<script setup lang="ts">
  import { AccordionItem, useForwardProps } from 'radix-vue';
  import type { AccordionItemProps } from 'radix-vue';
  import { computed } from 'vue';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<AccordionItemProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
  });

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <AccordionItem v-bind="forwardedProps" :class="cn('border-b last:border-b-0', props.class)">
    <slot />
  </AccordionItem>
</template>
